import { SpaceVars } from '../Variables/SpaceVariables.Interfaces'
import { StoreVars, UserVars } from '../Variables/Variables.Interfaces'

export enum FMSType {
  SiteLink = 'SiteLink',
  SSM = 'SSM',
  SSMCloud = 'SSMCloud',
  StorEdge = 'StorEdge',
  Tenant = 'Tenant',
  StorageMart = 'StorageMart',
  DoorSwap = 'DoorSwap',
  StorageCommander = 'StorageCommander',
  Storage360 = 'Storage360'
}

export interface FacilityInterface {
  [StoreVars.StoreId]: string
  [StoreVars.StoreLocationNumber]: string
  [StoreVars.StoreFMSType]?: string
  [StoreVars.StoreName]?: string
  [StoreVars.StoreFMSIntegrationId]?: string
  [StoreVars.StoreBrandId]?: string
}

export interface StoreInfo {
  // This should be depricated
  LocationName: string
  LocationAddress: string
  LocationPhone: string
  LocationOfficeHours: string
  LocationAccessHours: string
  LocationEmail: string
}

export enum SpaceType {
  STORAGE_UNIT = 'storage unit',
  PARKING = 'parking',
  RV_PARKING = 'rv parking'
}

// export enum SpaceFeatureName { // This is deprecated!
//   IsParking = 'IsParking',
//   Indoor = 'Indoor',
//   Power = 'Power',
//   Alarm = 'Alarm',
//   ClimateControl = 'ClimateControl',
//   FirstFloor = 'FirstFloor',
//   DriveUp = 'DriveUp',
//   UpperLevel = 'UpperLevel',
//   ElevatorAccess = 'ElevatorAccess'
// }
export enum SpaceFeature {
  STORAGE_UNIT = 'storage unit',
  PARKING = 'parking',
  RV_PARKING = 'rv parking',
  COMMERCIAL_WAREHOUSE = 'commercial warehouse',
  BOAT_PARKING = 'boat parking',
  LOCKER = 'locker',
  CLIMATE_CONTROL = 'climate control',
  OFFICE_SPACE = 'office space',
  FIRST_FLOOR = 'first floor',
  UNPAVED = 'unpaved',
  PAVED = 'paved',
  COVERED = 'covered',
  ENCLOSED = 'enclosed',
  PULL_THRU = 'pull thru',
  HEATED = 'heated',
  UPPER_LEVEL = 'upper level',
  INSIDE = 'inside',
  DRIVE_UP = 'drive up',
  ELEVATOR_ACCESS = 'elevator access',
  ALARM = 'alarm',
  POWER = 'power',
  WINE_STORAGE = 'wine storage',
  GUN_STORAGE = 'gun storage',
  SAFETY_DEPOSIT_BOX = 'safety deposit box',
  UPPER_STACK = 'upper stack',
  LOWER_STACK = 'lower stack'
}
export const SpaceTags = [
  // These are things we display as tags
  SpaceFeature.CLIMATE_CONTROL,
  SpaceFeature.BOAT_PARKING,
  SpaceFeature.LOCKER,
  SpaceFeature.COMMERCIAL_WAREHOUSE,
  SpaceFeature.OFFICE_SPACE,
  SpaceFeature.FIRST_FLOOR,
  SpaceFeature.UNPAVED,
  SpaceFeature.PAVED,
  SpaceFeature.COVERED,
  SpaceFeature.ENCLOSED,

  SpaceFeature.PULL_THRU,
  SpaceFeature.HEATED,
  SpaceFeature.UPPER_LEVEL,
  SpaceFeature.INSIDE,
  SpaceFeature.DRIVE_UP,
  SpaceFeature.ELEVATOR_ACCESS,
  SpaceFeature.ALARM,
  SpaceFeature.POWER,
  SpaceFeature.WINE_STORAGE,
  SpaceFeature.SAFETY_DEPOSIT_BOX,
  SpaceFeature.UPPER_STACK,
  SpaceFeature.LOWER_STACK
]

export const DefaultSpacePickerFeatureDisplayNames = {
  // [SpaceFeatureName.IsParking]: 'Parking',
  // [SpaceFeatureName.Indoor]: 'Indoor',
  // [SpaceFeatureName.Power]: 'Power',
  // [SpaceFeatureName.Alarm]: 'Alarm',
  // [SpaceFeatureName.ClimateControl]: 'Climate Control',
  // [SpaceFeatureName.FirstFloor]: 'First Floor',
  // [SpaceFeatureName.DriveUp]: 'Drive Up',
  // [SpaceFeatureName.UpperLevel]: 'Upper Level',
  // [SpaceFeatureName.ElevatorAccess]: 'Elevator Access',
  [SpaceFeature.OFFICE_SPACE]: 'Office Space',
  [SpaceFeature.COMMERCIAL_WAREHOUSE]: 'Commercial Warehouse',
  [SpaceFeature.BOAT_PARKING]: 'Boat Parking',
  [SpaceFeature.LOCKER]: 'Locker',
  [SpaceFeature.STORAGE_UNIT]: 'Storage Unit',
  [SpaceFeature.PARKING]: 'Parking',
  [SpaceFeature.RV_PARKING]: 'RV Parking',
  [SpaceFeature.CLIMATE_CONTROL]: 'Climate Control',
  [SpaceFeature.FIRST_FLOOR]: 'First Floor',
  [SpaceFeature.UNPAVED]: 'Unpaved',
  [SpaceFeature.PAVED]: 'Paved',
  [SpaceFeature.COVERED]: 'Covered',
  [SpaceFeature.ENCLOSED]: 'Enclosed',
  [SpaceFeature.PULL_THRU]: 'Pull Thru',
  [SpaceFeature.HEATED]: 'Heated',
  [SpaceFeature.UPPER_LEVEL]: 'Upper Level',
  [SpaceFeature.INSIDE]: 'Inside',
  [SpaceFeature.DRIVE_UP]: 'Drive Up',
  [SpaceFeature.ELEVATOR_ACCESS]: 'Elevator Access',
  [SpaceFeature.ALARM]: 'Alarm',
  [SpaceFeature.POWER]: 'Power',
  [SpaceFeature.WINE_STORAGE]: 'Alarm',
  [SpaceFeature.GUN_STORAGE]: 'Gun Storage',
  [SpaceFeature.SAFETY_DEPOSIT_BOX]: 'Power',
  [SpaceFeature.UPPER_STACK]: 'Upper Stack',
  [SpaceFeature.LOWER_STACK]: 'Lower Stack'
}

export interface SpaceInterface {
  id: string
  type: SpaceType
  name: string
  dimensions?: string
  unitRate?: string
  width?: number
  length?: number
  productTypeId?: number
  imageURL?: string
  costLow?: string
  costHigh?: string
  isParking?: boolean
  hasClimateControl: boolean
  isInside: boolean
  hasPower: boolean
  hasAlarm: boolean
  floor: number

  isUpperLevel?: boolean
  isHeated?: boolean
  isDriveUp?: boolean
  hasElevatorAccess?: boolean

  features?: SpaceFeature[]
}
export function SpaceInterfaceToSpaceVariables(_space: SpaceInterface): { [key: string]: string } {
  const space: any = { ..._space } || {}
  for (const key in space) {
    if (Object.prototype.hasOwnProperty.call(space, key)) {
      space[key] = String(space[key])
    }
  }

  return {
    [SpaceVars.SpaceId]: space.id,
    [SpaceVars.SpaceName]: space.name || '',
    [SpaceVars.SpaceDimensions]: space.dimensions || '',
    [SpaceVars.SpaceRate]: space.costLow || space.costHigh || '',
    [SpaceVars.SpaceHasClimateControl]:
      space.hasClimateControl || space.features.includes(SpaceFeature.CLIMATE_CONTROL) ? '1' : '0',
    [SpaceVars.SpaceIsInside]:
      space.isInside || space.features.includes(SpaceFeature.INSIDE) ? '1' : '0',
    [SpaceVars.SpaceHasPower]:
      space.hasPower || space.features.includes(SpaceFeature.POWER) ? '1' : '0',
    [SpaceVars.SpaceFloor]: String(space.floor),
    [SpaceVars.SpaceIsParking]:
      space.isParking || space.features.includes(SpaceFeature.PARKING) ? '1' : '0',
    [SpaceVars.SpaceIsDriveUp]:
      space.isDriveUp || space.features.includes(SpaceFeature.DRIVE_UP) ? '1' : '0',
    [SpaceVars.SpaceHasElevatorAccess]:
      space.hasElevatorAccess || space.features.includes(SpaceFeature.ELEVATOR_ACCESS) ? '1' : '0',
    [SpaceVars.SpaceHasAlarm]:
      space.hasAlarm || space.features.includes(SpaceFeature.ALARM) ? '1' : '0',
    [SpaceVars.SpaceFeatures]:
      space.features && space.features.constructor === Array ? space.features.join(',') : ''
  }
}
export function SpaceVariablesToSpaceInterface(variables: {
  [key: string]: string
}): SpaceInterface {
  const features = variables[SpaceVars.SpaceFeatures]
    ? (variables[SpaceVars.SpaceFeatures].split(',') as SpaceFeature[])
    : []

  return {
    id: variables[SpaceVars.SpaceId] || '',
    name: variables[SpaceVars.SpaceName] || '',
    dimensions: variables[SpaceVars.SpaceDimensions] || '',
    costLow: String(variables[SpaceVars.SpaceRate]) || '',
    costHigh: String(variables[SpaceVars.SpaceRate]) || '',
    hasClimateControl:
      variables[SpaceVars.SpaceHasClimateControl] === '1' ||
      features.includes(SpaceFeature.CLIMATE_CONTROL),
    isInside: variables[SpaceVars.SpaceIsInside] === '1' || features.includes(SpaceFeature.INSIDE),
    hasPower: variables[SpaceVars.SpaceHasPower] === '1' || features.includes(SpaceFeature.POWER),
    floor: Number(variables[SpaceVars.SpaceFloor] || '0'),
    isParking:
      variables[SpaceVars.SpaceIsParking] === '1' || features.includes(SpaceFeature.PARKING),
    isDriveUp:
      variables[SpaceVars.SpaceIsDriveUp] === '1' || features.includes(SpaceFeature.DRIVE_UP),
    hasElevatorAccess:
      variables[SpaceVars.SpaceHasElevatorAccess] === '1' ||
      features.includes(SpaceFeature.ELEVATOR_ACCESS),
    hasAlarm: variables[SpaceVars.SpaceHasAlarm] === '1' || features.includes(SpaceFeature.ALARM),
    type: variables[SpaceVars.SpaceIsParking] === '1' ? SpaceType.PARKING : SpaceType.STORAGE_UNIT,
    features: variables[SpaceVars.SpaceFeatures] ? features : []
  }
}

export interface RentalLead {
  tenantId?: string

  firstName: string
  lastName: string
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  zip: string
  countryCode?: string
  email: string
  phone: string
  comments: string
  unitSize?: string
}
export enum AccessCodeRequestResponseStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
  MISSING_PARAMS = 'missing params'
}
export interface AccessCodeRequestResponse {
  status: AccessCodeRequestResponseStatus
  accessCode?: string
  temporary?: boolean
  message?: string
}

export interface TenantInfo {
  // These map 1:1 to the User vars
  [UserVars.User_TenantId]: string
  [UserVars.User_Name]: string
  [UserVars.User_Email]: string
  [UserVars.User_Phone]: string
  [UserVars.User_AddressLine1]: string
  [UserVars.User_AddressLine2]: string
  [UserVars.User_City]: string
  [UserVars.User_State]: string
  [UserVars.User_Zip]: string

  [UserVars.User_CountryCode]?: string

  [UserVars.User_AccessCode]?: string
  [UserVars.User_DavinciAccessCode]?: string
  [UserVars.User_AccountStatus]?: TenantAccountStatus
  [UserVars.User_AccountPaymentStatus]?: TenantAccountPaymentStatus

  [StoreVars.StoreId]?: string

  [UserVars.User_PaymentDueDate]?: string
  [UserVars.User_AutoPayEnabled]?: string
  [UserVars.User_DaysPastDue]?: string
  [UserVars.User_UnitNumber]?: string
  [UserVars.User_UnitSize]?: string
  [UserVars.User_UnitFeatures]?: string
  [UserVars.User_AccountBalance]?: string

  [UserVars.User_PaymentDueDate]?: string
  [UserVars.User_AutoPayEnabled]?: string
  [UserVars.User_DaysPastDue]?: string

  [UserVars.User_UnitNumber]?: string
  [UserVars.User_UnitSize]?: string
  [UserVars.User_UnitFeatures]?: string
  [UserVars.User_AccountBalance]?: string

  [UserVars.User_Notes]?: string
}

export interface GetSpacesParams {
  priceField?: string
  includeTax?: boolean
}

export interface GetUnitsParams {
  facilityId: string
  priceField?: string
  includeTax?: boolean
}

export enum TenantAccountStatus {
  ACTIVE = 'active',
  PAST_DUE = 'past due', // remove me later after pushing all variables updates for TenantAccountStatus/TenantAccountPaymentStatus
  INACTIVE = 'inactive',
  UNKNOWN = 'unknown'
}

export enum TenantAccountPaymentStatus {
  PAST_DUE = 'past due',
  UNKNOWN = 'unknown'
}

export enum GetTenantResponseStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
  MISSING_PARAMS = 'missing params',
  MULTIPLE_TENANTS = 'multiple tenants',
  NOT_FOUND = 'not found'
}
export interface GetTenantResponse {
  status: GetTenantResponseStatus
  tenant?: TenantInfo
  message?: string
  tenants?: TenantInfo[]
}

export interface GetActiveTenantsResponse {
  status: GetTenantResponseStatus
  tenants?: TenantInfo[]
  message?: string
  errors?: string[]
}

export enum FMSCreateLeadStatus {
  SUCCESS = 'success',
  FAILURE = 'failure',
  DUPLICATE = 'duplicate'
}
export interface FMSCreateLeadResponse {
  status: FMSCreateLeadStatus
  tenantId?: string
  error?: string
}
